// import React, { useState, useEffect } from 'react';
// import { getSettings, updateSettings, changePassword } from '../utils/api';
// import toast from 'react-hot-toast';

// const SECTIONS = [
//   { key: 'general', label: 'General', fields: [
//     { key: 'company_name', label: 'Company Name', type: 'text' },
//     { key: 'company_tagline', label: 'Tagline', type: 'text' },
//     { key: 'company_description', label: 'About / Description', type: 'textarea' }
//   ]},
//   { key: 'contact', label: 'Contact Info', fields: [
//     { key: 'company_phone', label: 'Phone', type: 'text' },
//     { key: 'company_email', label: 'Email', type: 'email' },
//     { key: 'company_address', label: 'Address', type: 'text' },
//     { key: 'company_whatsapp', label: 'WhatsApp Number (with country code, no +)', type: 'text' }
//   ]},
//   { key: 'social', label: 'Social Media', fields: [
//     { key: 'social_instagram', label: 'Instagram URL', type: 'url' },
//     { key: 'social_facebook', label: 'Facebook URL', type: 'url' },
//     { key: 'social_youtube', label: 'YouTube URL', type: 'url' }
//   ]},
//   { key: 'homepage', label: 'Homepage Hero', fields: [
//     { key: 'hero_title', label: 'Hero Title (main line)', type: 'text' },
//     { key: 'hero_highlight', label: 'Hero Highlight (accent line)', type: 'text' },
//     { key: 'hero_subtitle', label: 'Hero Subtitle', type: 'textarea' }
//   ]},
//   { key: 'stats', label: 'Stats Bar', fields: [
//     { key: 'years_experience', label: 'Years of Experience', type: 'number' },
//     { key: 'projects_completed', label: 'Projects Completed', type: 'number' },
//     { key: 'happy_clients', label: 'Happy Clients', type: 'number' },
//     { key: 'awards_won', label: 'Awards Won', type: 'number' }
//   ]}
// ];

// export default function SettingsPage() {
//   const [settings, setSettings] = useState({});
//   const [loading, setLoading] = useState(true);
//   const [saving, setSaving] = useState(false);
//   const [activeTab, setActiveTab] = useState('general');
//   const [pwForm, setPwForm] = useState({ currentPassword: '', newPassword: '', confirmPassword: '' });
//   const [pwSaving, setPwSaving] = useState(false);

//   useEffect(() => {
//     getSettings().then(r => setSettings(r.data.data || {})).catch(() => {}).finally(() => setLoading(false));
//   }, []);

//   const handleChange = (key, value) => setSettings(p => ({ ...p, [key]: value }));

//   const handleSave = async (section) => {
//     setSaving(true);
//     try {
//       const sectionFields = SECTIONS.find(s => s.key === section)?.fields || [];
//       const payload = {};
//       sectionFields.forEach(f => { if (settings[f.key] !== undefined) payload[f.key] = settings[f.key]; });
//       await updateSettings(payload);
//       toast.success('Settings saved!');
//     } catch { toast.error('Save failed'); }
//     finally { setSaving(false); }
//   };

//   const handlePwChange = async (e) => {
//     e.preventDefault();
//     if (pwForm.newPassword !== pwForm.confirmPassword) { toast.error('Passwords do not match'); return; }
//     if (pwForm.newPassword.length < 6) { toast.error('Password must be at least 6 characters'); return; }
//     setPwSaving(true);
//     try {
//       await changePassword({ currentPassword: pwForm.currentPassword, newPassword: pwForm.newPassword });
//       toast.success('Password changed successfully');
//       setPwForm({ currentPassword: '', newPassword: '', confirmPassword: '' });
//     } catch (err) {
//       toast.error(err.response?.data?.message || 'Failed to change password');
//     } finally { setPwSaving(false); }
//   };

//   if (loading) return <div className="flex items-center justify-center py-20"><div className="w-8 h-8 border-2 border-brand-400 border-t-transparent rounded-full animate-spin" /></div>;

//   const allSections = [...SECTIONS, { key: 'password', label: 'Change Password' }];

//   return (
//     <div className="space-y-5">
//       <div>
//         <h1 className="font-display text-xl font-semibold text-surface-100">Settings</h1>
//         <p className="text-surface-500 text-sm mt-0.5">Manage site content and configuration</p>
//       </div>

//       <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
//         {/* Tabs */}
//         <div className="card p-2 h-fit">
//           {allSections.map(s => (
//             <button key={s.key} onClick={() => setActiveTab(s.key)}
//               className={`w-full text-left px-3 py-2.5 rounded text-sm transition-colors ${activeTab === s.key ? 'bg-brand-400/15 text-brand-400 font-medium' : 'text-surface-400 hover:text-surface-200 hover:bg-surface-700'}`}>
//               {s.label}
//             </button>
//           ))}
//         </div>

//         {/* Form */}
//         <div className="lg:col-span-3">
//           {SECTIONS.map(section => section.key === activeTab && (
//             <div key={section.key} className="card p-6 space-y-5">
//               <div className="flex items-center justify-between border-b border-surface-700 pb-4">
//                 <h2 className="font-display font-semibold text-surface-200">{section.label}</h2>
//                 <button onClick={() => handleSave(section.key)} disabled={saving} className="btn-primary py-2 px-4 text-sm">
//                   {saving ? 'Saving…' : 'Save Changes'}
//                 </button>
//               </div>
//               {section.fields.map(field => (
//                 <div key={field.key}>
//                   <label className="label">{field.label}</label>
//                   {field.type === 'textarea' ? (
//                     <textarea value={settings[field.key] || ''} onChange={e => handleChange(field.key, e.target.value)}
//                       className="input resize-y" rows={3} />
//                   ) : (
//                     <input type={field.type} value={settings[field.key] || ''} onChange={e => handleChange(field.key, e.target.value)}
//                       className="input" />
//                   )}
//                 </div>
//               ))}
//             </div>
//           ))}

//           {activeTab === 'password' && (
//             <div className="card p-6">
//               <h2 className="font-display font-semibold text-surface-200 border-b border-surface-700 pb-4 mb-5">Change Password</h2>
//               <form onSubmit={handlePwChange} className="space-y-4 max-w-sm">
//                 {[
//                   { name: 'currentPassword', label: 'Current Password' },
//                   { name: 'newPassword', label: 'New Password' },
//                   { name: 'confirmPassword', label: 'Confirm New Password' }
//                 ].map(f => (
//                   <div key={f.name}>
//                     <label className="label">{f.label}</label>
//                     <input type="password" value={pwForm[f.name]}
//                       onChange={e => setPwForm(p => ({ ...p, [f.name]: e.target.value }))}
//                       className="input" placeholder="••••••••" />
//                   </div>
//                 ))}
//                 <button type="submit" disabled={pwSaving} className="btn-primary py-2.5 w-full">
//                   {pwSaving ? 'Updating…' : 'Update Password'}
//                 </button>
//               </form>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }


import React, { useState } from 'react';
import { Save, Loader, Shield } from 'lucide-react';
import { changePassword } from '../utils/api';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';

export default function SettingsPage() {
  const { user } = useAuth();
  const [form, setForm] = useState({ current_password: '', password: '', password_confirmation: '' });
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    setForm(f => ({ ...f, [e.target.name]: e.target.value }));
    if (errors[e.target.name]) setErrors(errs => ({ ...errs, [e.target.name]: '' }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errs = {};
    if (!form.current_password) errs.current_password = 'Required';
    if (!form.password) errs.password = 'Required';
    else if (form.password.length < 8) errs.password = 'Min 8 characters';
    if (form.password !== form.password_confirmation) errs.password_confirmation = 'Passwords do not match';
    if (Object.keys(errs).length) { setErrors(errs); return; }

    setLoading(true);
    try {
      await changePassword(form);
      toast.success('Password changed successfully!');
      setForm({ current_password: '', password: '', password_confirmation: '' });
    } catch (err) {
      const msg = err.response?.data?.message || 'Failed to change password';
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-2xl">
      <div className="mb-6">
        <h1 className="text-xl font-semibold text-white">Settings</h1>
        <p className="text-white/40 text-sm mt-0.5">Manage your account settings</p>
      </div>

      {/* Profile Info */}
      <div className="card p-5 mb-4">
        <h2 className="font-medium text-white mb-4 text-sm">Account Information</h2>
        <div className="flex items-center gap-4">
          <div className="w-16 h-16 bg-primary-500/10 rounded-full flex items-center justify-center text-primary-400 text-2xl font-bold">
            {user?.name?.[0] || 'A'}
          </div>
          <div>
            <div className="text-lg font-semibold text-white">{user?.name}</div>
            <div className="text-white/40 text-sm">{user?.email}</div>
            <div className="flex items-center gap-1.5 mt-1">
              <Shield size={12} className="text-primary-400" />
              <span className="text-primary-400 text-xs capitalize">{user?.role?.replace('_', ' ')}</span>
            </div>
          </div>
        </div>
      </div>

      {/* Change Password */}
      <div className="card p-5">
        <h2 className="font-medium text-white mb-4 text-sm">Change Password</h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="label">Current Password</label>
            <input type="password" name="current_password" value={form.current_password} onChange={handleChange} placeholder="••••••••" className={`input ${errors.current_password ? 'border-red-500/50' : ''}`} />
            {errors.current_password && <p className="text-red-400 text-xs mt-1">{errors.current_password}</p>}
          </div>
          <div>
            <label className="label">New Password</label>
            <input type="password" name="password" value={form.password} onChange={handleChange} placeholder="Min 8 characters" className={`input ${errors.password ? 'border-red-500/50' : ''}`} />
            {errors.password && <p className="text-red-400 text-xs mt-1">{errors.password}</p>}
          </div>
          <div>
            <label className="label">Confirm New Password</label>
            <input type="password" name="password_confirmation" value={form.password_confirmation} onChange={handleChange} placeholder="Repeat new password" className={`input ${errors.password_confirmation ? 'border-red-500/50' : ''}`} />
            {errors.password_confirmation && <p className="text-red-400 text-xs mt-1">{errors.password_confirmation}</p>}
          </div>
          <button type="submit" disabled={loading} className="btn-primary">
            {loading ? <><Loader size={14} className="animate-spin" /> Saving...</> : <><Save size={14} /> Change Password</>}
          </button>
        </form>
      </div>
    </div>
  );
}